import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import berlinWallPNG from '~/assets/images/history/history-berlin-wall.png'
import berlinWallWEBP from '~/assets/images/history/history-berlin-wall.webp'
import { Styles as S } from '~/pages/history/multipleChoice/studyGoal/styles'
import { Styles as BinaryS } from '~/pages/onboarding/quizBinaryChoice/libs/styles'
import { OptionType } from '~/shared/constants/commonConstants'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const QUESTION = 'When did the Berlin Wall fall?'

const OPTIONS = [
  { key: '1961', i18nKey: 'first' },
  { key: '1989', i18nKey: 'second' },
  { key: '1999', i18nKey: 'third' },
] as const

const BerlinWall = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('history')
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: QUESTION,
  })

  return (
    <BinaryS.Root>
      <BinaryS.StyledContainer>
        <div>
          <BinaryS.Question>
            <Trans ns="history" i18nKey="onboarding.historyBerlinWall.title" />
          </BinaryS.Question>

          <BinaryS.ImageContainer>
            <picture>
              <source srcSet={berlinWallWEBP} type="image/webp" />
              <img src={berlinWallPNG} alt="Berlin Wall" />
            </picture>
          </BinaryS.ImageContainer>
        </div>

        <div>
          {OPTIONS.map(({ key, i18nKey }) => (
            <S.StyledOption
              key={key}
              type={OptionType.RADIO}
              value={key}
              name="berlinWall"
              disabled={isAnswersDisabled}
              checked={answer === key}
              onChange={(optionValue) => {
                setAnswer(optionValue)
                setIsAnswersDisabled(true)
                handleChange(optionValue, handleContinue)
              }}
            >
              <S.Value>
                <S.ValueText>
                  {t(`onboarding.historyBerlinWall.options.${i18nKey}`)}
                </S.ValueText>
              </S.Value>
            </S.StyledOption>
          ))}
        </div>
      </BinaryS.StyledContainer>
    </BinaryS.Root>
  )
}

export default BerlinWall
